export const reportDataJson = [
  {
    imgPath: 'StudentIcon',
    category: 'student',
    title: 'Student Statistics Reports',
    reports: [
      { id: 1, title: 'Active job roles report' },
      { id: 2, title: 'Placement reports' },
      { id: 3, title: 'CTC report' },
      { id: 4, title: 'Prior education background report' },
      { id: 5, title: 'Prior work experience report' },
      { id: 6, title: 'Placement - Sector based report' },
      { id: 7, title: 'Placement - Function based report' },
      { id: 8, title: 'Placement absentee report' },
      { id: 9, title: 'Placement Statistics Report' },
      { id: 10, title: 'Custom report' },
    ],
  },
  {
    imgPath: 'ManagementIcon',
    category: 'corporate',
    title: 'Management Reports',
    reports: [
      { id: 1, title: 'NIRF/NAAC report' },
      { id: 2, title: 'Top hiring companies' },
      { id: 3, title: 'Top/Least Paying Companies' },
      { id: 4, title: 'Companies with zero hires' },
    ],
  },
]

export const reportData = {
  corporate: [
    { id: 1, title: 'NIRF/NAAC report' },
    { id: 2, title: 'Top hiring companies' },
    { id: 3, title: 'Companies with zero hires' },
    { id: 4, title: 'Top/Least Paying Companies' },
  ],
  student: [
    { id: 1, title: 'Active job roles report' },
    { id: 2, title: 'CTC report' },
    { id: 3, title: 'Placement absentee report' },
    { id: 4, title: 'Prior education background report(Only for PG)' },
    { id: 5, title: 'Prior work experience report(Only for PG)' },
    { id: 6, title: 'Placement - Sector based report' },
    { id: 7, title: 'Placement - Function based report' },
    { id: 8, title: 'Placement reports' },
    { id: 9, title: 'Placement Statistics Report' },
    { id: 10, title: 'Custom report' },
  ],
}

export const reportFields = Object.fromEntries(
  Object.entries({
    'Active job roles report': [
      'Role name, Company Name, CTC, CTC Period ( Annually/Monthly), No. of students applied, In evaluation process, Rejected, Absent, Intent to Offer, Offer Released, Offer Accepted, Offer Declined.',
    ],
    'CTC report': [
      'Highest CTC, Lowest CTC, Mean, Median, CTC range, No. of students placed.',
    ],
    'Placement absentee report': [
      'Registration no., Student name,  Mobile number, Email Address, Corporate Name, Role name, Evaluation process stage - Absent, Date of Absence.',
    ],
    'Prior education background report(Only for PG)': [
      'Industry, Prior education (Domain, Degree, Dept.), No. of students.',
    ],
    'Prior work experience report(Only for PG)': [
      'Industry, No. of months of prior work experience, No. of students.',
    ],
    'Placement - Sector based report': [
      'Sector, No. of roles floated, No. of students placed, Average CTC.',
    ],
    'Placement - Function based report': [
      'Function, No. of roles floated, No. of students placed, Average CTC.',
    ],
    'Placement reports': [' Total Students, Placed, Unplaced, Opted out.'],
    'Placement Statistics Report': [
      'Corporate Name, Sector, Role Name, CTC,CTC Period ( Annually/Monthly), Location, No. of Students Applied, Qualified for Evaluation Process, Round 1 - Selected, Round 2 - Selected, No. of Students - Intent to Offer, No. of Students Accepted the Offer, SPOC Name, SPOC Number, SPOC Email.',
    ],
    'Custom report': ['Custom Criteria'],
  }).map(([key, value]) => [
    key,
    value.map(str =>
      str
        .split(',')
        .map(item => ` ${item.trim()} `)
        .join(',')
    ),
  ])
)

export const corporateFields = Object.fromEntries(
  Object.entries({
    'NIRF/NAAC report': [
      'Academic year, (Total no. of students - Male, Female, Others), No. of students placed, No. of students unplaced, No. of students opted out, No. of Students Opted for Entrepreneurship, No. of students opted for Higher Education, Median salary of placed graduates.',
    ],
    'Top hiring companies': ['(Corporate, No. of students hired)'],
    'Companies with zero hires': [
      'Corporate, Role Name, CTC, CTC Period (Annually/Monthly)',
    ],
    'Top/Least Paying Companies': [
      '(Corporate, Role Name, CTC, No. of students hired)',
    ],
  }).map(([key, value]) => [
    key,
    value.map(str =>
      str
        .split(',')
        .map(item => item.trim())
        .join(', ')
    ),
  ])
)

export const labelChangeFunction = label => {
  switch (label) {
    case 'PLACEMENT':
      return 'Placement'
    case 'INTERNSHIP':
      return 'Internships'
    case 'INTERNSHIP_PPO':
      return 'Internship + PPO'
    case 'APPRENTICESHIP':
      return 'Apprenticeship'
    case 'GIGS':
      return 'Gigs'
  }
}

export const jobCategoryFilterData = data => {
  if (data?.length > 0) {
    let jobCat = data.map(item => ({
      label: labelChangeFunction(item),
      value: item,
    }))
    return jobCat
  }
}

export const reportUrlMapping = {
  'Active job roles report': 'activejobrole',
  'CTC report': 'ctc',
  'Placement absentee report': 'absentees',
  'Prior education background report(Only for PG)': 'education',
  'Prior work experience report(Only for PG)': 'workexp',
  'Placement - Sector based report': 'sector',
  'Placement - Function based report': 'function',
  'Placement reports': 'placementReport',
  'Placement Statistics Report': 'statisticsReport',
  'Custom report': 'custom',
  'NIRF/NAAC report': 'nirf_report',
  'Top hiring companies': 'topHiringCompanies',
  'Companies with zero hires': 'zeroHiringCompanies',
  'Top/Least Paying Companies': 'payingcompanies',
}

export const hiredItemsData = {
  'Top hiring companies': [
    { label: 'Top 10', value: 'Top10' },
    { label: 'Top 20', value: 'Top20' },
    { label: 'Top 30', value: 'Top30' },
  ],
  'Top/Least Paying Companies': [
    { label: 'Top 10', value: 'Top10' },
    { label: 'Top 20', value: 'Top20' },
    { label: 'Least 10', value: 'Least10' },
    { label: 'Least 20', value: 'Least20' },
  ],
}

export const getSortingValues = (selectedReport, selectedButton) => {
  let sortingConfig

  if (selectedReport === 'Top hiring companies') {
    if (selectedButton === 'Top10') {
      sortingConfig = {
        pageLimit: 10,
        orderBy: 'DESC',
        sort: 'max_compensation',
      }
    } else if (selectedButton === 'Top20') {
      sortingConfig = {
        pageLimit: 20,
        orderBy: 'DESC',
        sort: 'max_compensation',
      }
    } else if (selectedButton === 'Top30') {
      sortingConfig = {
        pageLimit: 30,
        orderBy: 'DESC',
        sort: 'max_compensation',
      }
    }
  } else if (selectedReport === 'Top/Least Paying Companies') {
    if (selectedButton === 'Top10') {
      sortingConfig = {
        pageLimit: 10,
        orderBy: 'DESC',
        sort: 'jr.max_compensation',
      }
    } else if (selectedButton === 'Top20') {
      sortingConfig = {
        pageLimit: 20,
        orderBy: 'DESC',
        sort: 'jr.max_compensation',
      }
    } else if (selectedButton === 'Least10') {
      sortingConfig = {
        pageLimit: 10,
        orderBy: 'ASC',
        sort: 'jr.max_compensation',
      }
    } else if (selectedButton === 'Least20') {
      sortingConfig = {
        pageLimit: 20,
        orderBy: 'ASC',
        sort: 'jr.max_compensation',
      }
    }
  }

  return sortingConfig
}

export const reportNameMap = {
  'Placement - Sector based report': 'Sector based report',
  'Placement - Function based report': 'Function based report',
  'Placement absentee report': 'Absentee report',
  'Placement Statistics Report': 'Statistics report',
}

export const excludeCategoryReports = [
  'Prior education background report(Only for PG)',
  'Prior work experience report(Only for PG)',
]
